import { useContext } from "react";
import { useModal } from "react-modal-hook";
import { FIRMWithWarnings } from "common-client/utils/firmInfoWarnings";
import { EditableMode } from "common-client/utils/firms";
import { AuthContext } from "../../../Authorization/AuthContext";
import Modal from "../../../Common/Modal";
import { BaseFloodEditModal } from "./BaseFloodEditModal";
import { FIRMEditForm } from "./FIRMEditModal";
import FloodzoneEditForm from "./FloodzoneEditModal";
import { Property } from "./types";

const ModalContent = ({
  mode,
  property,
  firm,
  hideModal,
  ...props
}: {
  mode?: Maybe<EditableMode>;
  property?: NonNullable<Property>;
  firm?: Maybe<FIRMWithWarnings>;
  hideModal: () => void;
}) => {
  if (!firm || !mode || !property) return null;

  switch (mode) {
    case "floodzone":
      return (
        <FloodzoneEditForm
          property={property}
          firm={firm}
          hideModal={hideModal}
          {...props}
        />
      );
    case "elevation":
    case "depth":
      return (
        <BaseFloodEditModal
          property={property}
          firm={firm}
          mode={mode}
          hideModal={hideModal}
          {...props}
        />
      );
    case "floodway":
    case "coastalA":
    case "panel":
    case "datum":
      return (
        <FIRMEditForm
          property={property}
          firm={firm}
          mode={mode}
          hideModal={hideModal}
          {...props}
        />
      );
  }
};

export const useEditFIRMInfoModal = ({
  clearEditFirmInfoProps,
  ...props
}: {
  mode?: Maybe<EditableMode>;
  property?: NonNullable<Property>;
  firm?: FIRMWithWarnings;
  clearEditFirmInfoProps: () => void;
}) => {
  const authContext = useContext(AuthContext);
  const [showModal, hideModal] = useModal(() => {
    return (
      <Modal onRequestClose={clearEditFirmInfoProps}>
        <AuthContext.Provider value={authContext}>
          <ModalContent {...props} hideModal={clearEditFirmInfoProps} />
        </AuthContext.Provider>
      </Modal>
    );
  }, [props.mode, props.property, props.firm]);

  return [showModal, hideModal] as const;
};
